export default "__VITE_ASSET__USesX1NY__"